import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableContractSignableView = Loadable({
  loader: function loader() {
    return import('../ContractSignableView.jsx');
  },
  loading: ComponentLoading
});
export default LoadableContractSignableView;